import {
    CHANGE_DATE_START,
    CHANGE_DATE_END,
    SESSION_ACCESS_DENIED
} from '../actions';
import moment from 'moment'
// import { getYearMontDate } from "../../helpers/Utils";

let today = moment();
let filterDayAgo = moment().subtract(7,'d')

const INIT_STATE = {
	dateStart: filterDayAgo,
  dateEnd: today
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case CHANGE_DATE_START:
		  return { ...state, dateStart:action.payload};
    case CHANGE_DATE_END:
		  return { ...state, dateEnd:action.payload};
    case SESSION_ACCESS_DENIED:
      return {  message: action.payload};
		default: return { ...state };
	}
}
